export default {"src":"/_next/static/media/asks.86cbbb40.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};